module.exports = __webpack_public_path__ + "static/media/no_data.a8f74c91.svg";